import {
  Card,
  Theme,
  Typography,
  Button,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { ReactElement } from "react";
import Translator from "../services/Translator";

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    width: "250px",
  },
  actions: {
    float: "right",
  },
  delete: {
    color: theme.palette.error.dark,
  },
}));

function DeleteImageCard({
  onCancel,
  onDelete,
  final,
}: {
  onCancel: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
  final: boolean;
}): ReactElement {
  const classes = useStyles({});

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          {Translator.translate("components.deleteimagecard.title")}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {Translator.translate(
            final
              ? "components.deleteimagecard.textFinal"
              : "components.deleteimagecard.text"
          )}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button size="small" variant="contained" onClick={onCancel}>
          {Translator.translate("components.deleteimagecard.cancel")}
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.delete}
          onClick={onDelete}
        >
          {Translator.translate("components.deleteimagecard.delete")}
        </Button>
      </CardActions>
    </Card>
  );
}

export default DeleteImageCard;
